import { CloseSharp, Search } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Slide,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useContext, useState } from "react";
import Draggable from "react-draggable";
import ServiceImage1 from "../../Assets/Dashboard/ServiceImage1.svg";
import { AppContext } from "../context/app.context";
import { NoSearchIcon } from "../Styles/Icons";
import { useNavigate } from "react-router-dom";
import Loading from "../../Assets/Gif/Loading5k.gif";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const SearchPop = ({ searchPop, setSearchPop }) => {
  const theme = useTheme();
  const Navigate = useNavigate();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { branchValue } = useContext(AppContext);

  //useState
  const [searchValue, setSearchValue] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(false);

  //Functions
  const handleClose = () => {
    setSearchPop(false);
  };

  //APIs
  const searchServiceProduct = async (e) => {
    try {
      const response = await global.$axios.post(
        "dashboard/searchServiceAndProduct",
        {
          query: e,
          branch_id: branchValue?._id || null,
        }
      );
      if (response.data.status === "success") {
        setSearchData(response.data.data);
        setLoading(false);
      } else {
        setSearchData([]);
        console.log("Search API Issue");
        setLoading(false);
      }
    } catch (error) {
      console.log("Search API Issue", error);
      setLoading(false);
    }
  };
  return (
    <Dialog
      fullScreen={fullScreen}
      open={searchPop}
      fullWidth={true}
      maxWidth={"sm"}
      TransitionComponent={Transition}
      aria-labelledby="draggable-dialog-title"
      PaperComponent={PaperComponent}
      onClose={handleClose}
    >
      <Grid sx={{ py: 2, px: 3 }}>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DialogTitle>
            <Typography sx={{ p: 0, color: "#071CB7", fontWeight: 600 }}>
              Search Product or Service
            </Typography>
          </DialogTitle>
          <IconButton sx={{ p: 0 }} onClick={handleClose}>
            <CloseSharp sx={{ color: "red" }} />
          </IconButton>
        </Grid>

        <DialogContent>
          <Grid
            sx={{ alignItems: "center", justifyContent: "center" }}
            container
          >
            <TextField
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                e.target.value !== "" && searchServiceProduct(e.target.value);
              }}
              sx={{
                ".css-16slxrv-MuiInputBase-input-MuiOutlinedInput-input": {
                  fontSize: 14,
                },
              }}
              autoFocus
              size="small"
              fullWidth
              placeholder="Type here to search..."
              InputProps={{
                type: "search",
                startAdornment: (
                  <InputAdornment position="start">
                    <Search fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid
            sx={{
              mt: 3,
              maxHeight: { md: "50vh", xs: "60vh" },
              minHeight: { md: "50vh", xs: "60vh" },
              overflowY: "auto",
              p: 1,
            }}
          >
            {loading ? (
              <Grid
                sx={{ alignItems: "center", justifyContent: "center" }}
                container
              >
                <Box
                  component="img"
                  sx={{
                    height: 300,
                    width: 300,
                    borderRadius: 2,
                  }}
                  alt="5k Car Care"
                  src={Loading}
                />
              </Grid>
            ) : searchData?.length > 0 ? (
              searchData?.map((item, index) => {
                return (
                  <Grid
                    sx={{
                      p: 2,
                      borderRadius: 1,
                      my: 3,
                      boxShadow: 2,
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      cursor: "pointer",
                    }}
                    key={index}
                    onClick={() => {
                      item?.type === "Product"
                        ? Navigate(
                            `/app/ViewProduct/?productId=${btoa(
                              btoa(item?._id)
                            )}`
                          )
                        : Navigate("/app/Booking", {
                            state: { data: item },
                          });
                      handleClose();
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        height: "70px",
                        width: "70px",
                        borderRadius: 2,
                        objectFit: "contain",
                        boxShadow: 2,
                      }}
                      alt="5k Car Care"
                      src={item?.image || item?.service_image || ServiceImage1}
                    />

                    <Grid>
                      <Typography sx={{ fontWeight: 600, color: "#0F1CB7" }}>
                        {item?.name}
                      </Typography>
                      <Typography sx={{ fontSize: 12 }}>
                        Category : {item?.type}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              })
            ) : (
              <Grid
                sx={{ alignItems: "center", justifyContent: "center" }}
                container
              >
                <NoSearchIcon width={250} height={250} />
              </Grid>
            )}
          </Grid>
        </DialogContent>
      </Grid>
    </Dialog>
  );
};

export default SearchPop;
